import '../social_content_context_view.js.coffee'
Monitoring.Views ||= {}

class Monitoring.Views.YoutubeContentContextView extends Monitoring.Views.SocialContentContextView

  newSearch: =>
    contextClasses = []
    contextClasses.push Monitoring.Views.YoutubeContentParentPostView
    contextClasses.push Monitoring.Views.YoutubeContentPreviousCommentsView
    contextClasses.push Monitoring.Views.YoutubeContentFollowingCommentsView

    _.each(contextClasses, (contextClass) =>
      new contextClass({el: @$el, socialContent: @socialContent}).fetch()
    )
    @show()
